import { OnAnimationFrame } from "../../library-js/animation/OnAnimationFrame";
import { AttributeValue } from "../../library-js/dom-tools/AttributeValue";
import { ElementAttribute } from "../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../library-js/dom-tools/ElementType";
import { UserAgentDeviceTypes } from "../../library-js/dom/UserAgentDeviceType";

export class RenderQuality
{
  static readonly type   = new ElementAttribute( "render--quality" );
  static readonly setter = new ElementAttribute( "render--quality--setter" );

  static readonly onlyOnQuality  = new ElementAttribute( "only--on--render--quality" );

  static readonly low  = new AttributeValue( RenderQuality.type, "low" ); 
  static readonly mid  = new AttributeValue( RenderQuality.type, "mid" ); 
  static readonly high = new AttributeValue( RenderQuality.type, "high" ); 

  private static _initialized = false;
  private static _fps = 60;
  private static _lastTime = 0; 
  private static _changedRenderQuality = new Date().getTime() + 5000;
  private static _loadBlockTime            = new Date().getTime() + 3000;
  private static _upgradeIntervall = 5000;
  private static _highRenderWidth = 2560;
  private static _currentValue:string = null;

  static get()
  {
    return RenderQuality.type.from( document.documentElement ); 
  }

  static get isHighQuality()
  {
    return RenderQuality.get() === RenderQuality.high.value;
  }

  static applyOnDocument( onAnimationFrame:OnAnimationFrame )
  {
    RenderQuality.initialize( onAnimationFrame );
  } 

  static initialize( onAnimationFrame:OnAnimationFrame )
  {
    if ( this._initialized )
    {
      return;
    }

    this._initialized = true;

    let deviceType = UserAgentDeviceTypes.attribute.from( document.body );

    if ( UserAgentDeviceTypes.PC === deviceType )
    {
      let renderWidth = window.screen.width * window.devicePixelRatio;

      if ( renderWidth <= RenderQuality._highRenderWidth )
      {
        RenderQuality.high.set( document.documentElement );
      }
      else
      {
        RenderQuality.mid.set( document.documentElement );
      }
      
    }


    onAnimationFrame.addListener(
      ( )=>
      {
        let setterElement = RenderQuality.setter.queryDoc(); 

        let setterValue = setterElement ? RenderQuality.setter.from( setterElement ) : "auto";

        if ( setterValue === "auto" )
        {          
          let currentValue = RenderQuality.type.from( document.documentElement, "low" );

          setterValue = currentValue;

          let deviceType = UserAgentDeviceTypes.attribute.from( document.body );
          
          if ( UserAgentDeviceTypes.PC === deviceType )
          {
            let renderWidth = window.screen.width * window.devicePixelRatio;

            let time = new Date().getTime();
            let elapsed = time - RenderQuality._lastTime;

            
            RenderQuality._lastTime = time;

            if ( elapsed > 200 )
            {
              return;
            }

            let fps = 1000 / ( Math.max( 1, elapsed ) );
            
            if ( fps > RenderQuality._fps )
            {
              RenderQuality._fps += 0.01 * ( fps - RenderQuality._fps );
            }
            else
            {
              RenderQuality._fps += 0.01 * ( fps - RenderQuality._fps );
            }
                     

            if ( time > this._loadBlockTime )
            {            
              let elapsedSinceChange = time - RenderQuality._changedRenderQuality;

              if ( RenderQuality._fps > 50 && elapsedSinceChange > this._upgradeIntervall )
              { 
                if ( currentValue === RenderQuality.low.value )
                {
                  setterValue = RenderQuality.mid.value;
                  RenderQuality._changedRenderQuality = time;
                }
                else if ( renderWidth <= RenderQuality._highRenderWidth && currentValue === RenderQuality.mid.value )
                {
                  setterValue = RenderQuality.high.value;
                  RenderQuality._changedRenderQuality = time;
                }
              }
              else if ( RenderQuality._fps < 30 )
              {
                if ( currentValue === RenderQuality.high.value )
                {
                  setterValue = RenderQuality.mid.value;
                  RenderQuality._changedRenderQuality = time;
                }
                else if ( currentValue === RenderQuality.mid.value )
                {
                  setterValue = RenderQuality.low.value;
                  RenderQuality._changedRenderQuality = time;
                }
              } 

            }

            
            
          }


        }

        
        if ( 
          RenderQuality._currentValue == null || 
          RenderQuality._currentValue != setterValue 
        )
        {
          RenderQuality._currentValue = setterValue;
          RenderQuality.type.to( document.documentElement, setterValue );
        }

        
      } 
    );
  }


  
}